import { render, staticRenderFns } from "./UILayer.vue?vue&type=template&id=477c36c2&scoped=true&"
import script from "./UILayer.vue?vue&type=script&lang=js&"
export * from "./UILayer.vue?vue&type=script&lang=js&"
import style0 from "./UILayer.vue?vue&type=style&index=0&id=477c36c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c36c2",
  null
  
)

export default component.exports